import type { AccountInfo } from '@solana/web3.js'
import type { Buffer } from 'node:buffer'
import { useWallet } from '@solana/wallet-adapter-vue'
import debounce from 'lodash-es/debounce'
import { defineStore } from 'pinia'
import { useEmitter } from '~/hooks/emitter'
import { ACCOUNT_CHANGE_EVENT, WALLET_DISCONNECT_EVENT } from '~/hooks/wallet'
import { useConnectionStore } from '~/store/connection'
import { lamportsToSol } from '~/utils'

const ACCOUNT_CHANGE_DEBOUNCE = 500

export const useBalanceStore = defineStore('balance', () => {
  const connectionStore = useConnectionStore()
  const { publicKey } = useWallet()
  const emitter = useEmitter()

  const nativeBalance = ref(0)
  const hasTokenAccount = ref<boolean>(false)
  const tokenBalanceLoading = ref<boolean>(false)
  const tokenBalance = ref(0)

  const solBalance = computed(() => lamportsToSol(nativeBalance.value))

  const _onAccountChange = debounce(async (acc: AccountInfo<Buffer> | null) => {
    nativeBalance.value = acc?.lamports ?? 0
    console.log('[Balance] SOL:', nativeBalance.value)
  }, ACCOUNT_CHANGE_DEBOUNCE)

  const _onDisconnect = () => {
    tokenBalanceLoading.value = false
    nativeBalance.value = 0
    tokenBalance.value = 0
  }

  emitter.on(ACCOUNT_CHANGE_EVENT, _onAccountChange)
  emitter.on(WALLET_DISCONNECT_EVENT, _onDisconnect)

  watch(
    publicKey,
    (pk) => {
      if (pk) {
        connectionStore.connection.getAccountInfo(pk).then(_onAccountChange)
        tokenBalanceLoading.value = true
      }
    },
    { immediate: true },
  )

  return {
    solBalance,
    nativeBalance,

    // tokens
    hasTokenAccount,
    tokenBalanceLoading,
    tokenBalance,
  }
})
